// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.matriz-grid {
  display: grid;
  grid-template-columns: 100px repeat(4, 1fr);
  grid-auto-rows: 60px;
  gap: 4px;
  padding: 4px;
}
.matriz-grid .top-label {
  display: flex;
  padding-right: 1px;
  align-items: end;
  justify-content: flex-start;
}
.matriz-grid .top-label-text {
  margin-bottom: 8px !important;
  font-size: 10px !important;
  font-weight: 700;
  color: var(--sebrae-blue-2);
  text-align: right;
}
.matriz-grid .top-label-text span {
  font-weight: 400;
}
.matriz-grid .top-empty {
  background: none;
}
.matriz-grid .vazio {
  display: flex;
  text-align: right;
  align-items: center;
}
.matriz-grid .vazio p {
  margin: 0 !important;
  font-size: 10px !important;
  font-weight: 700;
  color: var(--sebrae-blue-2);
}
.matriz-grid .vazio p span {
  font-size: 8px;
  font-weight: 400;
}
.matriz-grid .coluna-label,
.matriz-grid .linha-label {
  display: flex;
  font-size: 11px;
  font-weight: 400;
  text-align: center;
  align-items: center;
  justify-content: center;
  color: var(--sebrae-black);
}
.matriz-grid .tooltip {
  position: absolute;
  bottom: 120%;
  left: 50%;
  transform: translateX(-50%);
  background: #333;
  color: white;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 10;
  opacity: 0;
  animation: fadeIn 0.2s forwards;
}
@keyframes fadeIn {
  to {
    opacity: 1;
  }
}
.matriz-grid .celula {
  position: relative;
  min-height: 58px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.matriz-grid .celula .pin {
  position: absolute;
  pointer-events: none;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
}`, "",{"version":3,"sources":["webpack://./src/components/matriz/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,2CAAA;EACA,oBAAA;EACA,QAAA;EACA,YAAA;AACF;AAEE;EACE,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;AAAJ;AAEI;EACE,6BAAA;EACA,0BAAA;EACA,gBAAA;EACA,2BAAA;EACA,iBAAA;AAAN;AAEM;EACE,gBAAA;AAAR;AAKE;EACE,gBAAA;AAHJ;AAME;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;AAJJ;AAMI;EACE,oBAAA;EACA,0BAAA;EACA,gBAAA;EACA,2BAAA;AAJN;AAMM;EACE,cAAA;EACA,gBAAA;AAJR;AASE;;EAEE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;AAPJ;AAeE;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,+BAAA;AAbJ;AAgBE;EACE;IACE,UAAA;EAdJ;AACF;AAiBE;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAfJ;AAiBI;EACE,kBAAA;EACA,oBAAA;EACA,gCAAA;EACA,QAAA;EACA,SAAA;AAfN","sourcesContent":[".matriz-grid {\n  display: grid;\n  grid-template-columns: 100px repeat(4, 1fr);\n  grid-auto-rows: 60px;\n  gap: 4px;\n  padding: 4px;\n  // border: 1px solid #f1f1f1;\n\n  .top-label {\n    display: flex;\n    padding-right: 1px;\n    align-items: end;\n    justify-content: flex-start;\n\n    &-text {\n      margin-bottom: 8px !important;\n      font-size: 10px !important;\n      font-weight: 700;\n      color: var(--sebrae-blue-2);\n      text-align: right;\n\n      span {\n        font-weight: 400;\n      }\n    }\n  }\n\n  .top-empty {\n    background: none;\n  }\n\n  .vazio {\n    display: flex;\n    text-align: right;\n    align-items: center;\n\n    p {\n      margin: 0 !important;\n      font-size: 10px !important;\n      font-weight: 700;\n      color: var(--sebrae-blue-2);\n\n      span {\n        font-size: 8px;\n        font-weight: 400;\n      }\n    }\n  }\n\n  .coluna-label,\n  .linha-label {\n    display: flex;\n    font-size: 11px;\n    font-weight: 400;\n    text-align: center;\n    align-items: center;\n    justify-content: center;\n    color: var(--sebrae-black);\n  }\n\n  // .linha-label {\n  //   text-align: left;\n  //   justify-content: flex-start;\n  // }\n\n  .tooltip {\n    position: absolute;\n    bottom: 120%;\n    left: 50%;\n    transform: translateX(-50%);\n    background: #333;\n    color: white;\n    padding: 6px 10px;\n    border-radius: 6px;\n    font-size: 12px;\n    white-space: nowrap;\n    z-index: 10;\n    opacity: 0;\n    animation: fadeIn 0.2s forwards;\n  }\n\n  @keyframes fadeIn {\n    to {\n      opacity: 1;\n    }\n  }\n\n  .celula {\n    position: relative;\n    min-height: 58px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n\n    .pin {\n      position: absolute;\n      pointer-events: none;\n      transform: translate(-50%, -50%);\n      top: 50%;\n      left: 50%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
